/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://v77piz3ltk.execute-api.us-east-2.amazonaws.com/alkarim",
            "region": "us-east-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://szi5l5jv6nenfguauk367an34e.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-h5zz7wfprfgcpfqqqduaspfwgy",
    "aws_cognito_identity_pool_id": "us-east-2:e543f803-f66e-4a77-99c9-d98b8ce2c64d",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_fMBGsz0Ok",
    "aws_user_pools_web_client_id": "74gqkrv9a6pviedsdgttrkj7he",
    "oauth": {
        "domain": "calllcentersolution-alkarim.auth.us-east-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://pabloabdo.anyware.software/,https://pabloabdo.anyware.software/",
        "redirectSignOut": "https://pabloabdo.anyware.software/login/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE",
        "APPLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "PHONE_NUMBER"
    ],
    "aws_user_files_s3_bucket": "callcentersolutionassests102613-alkarim",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
